import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'

const ListComponent = lazy(() => import('./components/List'))

const APIUsageTemplateModule: RouteObject = {
    path: 'developer/api-usage-templates',
    children: [
        {
            path: '',
            element: <ListComponent />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default APIUsageTemplateModule
